module.exports = __webpack_public_path__ + "img/female.04ae8d9c.png";